// Configuraciones
//import { ADMIN_PRIVATE_WRAPPER } from '@shared/constants/config';

export const VENTA_ONLINE = 'BL-0001233';

export const MODULE_PATHS_CONSTANTS = {
  BASE_ROUTE: 'renewals',
  // Automóviles
  LISTADO_AUTOMOVILES: 'list-car-insurances',
  LISTADO_MULTISEGUROS: 'list-multi-insurance',
  DETALLE_AUTOMOVIL: 'car-insurance-detail/:id/:notRenewed',
  DETALLE_AUTOMOVIL_LINK: 'car-insurance-detail',
  DETALLE_MULTISEGUROS: 'multi-insurance-detail/:id',
  DETALLE_MULTISEGUROS_LINK: 'multi-insurance-detail',
  LISTADO_GARANTIAS: 'list-guarantees',
  DETALLE_GARANTIA: 'guarantee-detail/:id',
  DETALLE_GARANTIA_LINK: 'guarantee-detail',
};

export const generateFullModuleRoute = (route: string): string => {
  return `${MODULE_PATHS_CONSTANTS.BASE_ROUTE}/${route}`;
};

export const MODULE_NAVIGATION_MENU = [
  {
    title: 'Renovaciones',
    collapsed: true,
    collapsable: true,
    activated: true,
    navigationItems: [
      {
        icon: 'pi pi-car',
        route: generateFullModuleRoute(
          MODULE_PATHS_CONSTANTS.LISTADO_AUTOMOVILES
        ),
        title: 'Automóviles',
        activated: true,
      },
      {
        icon: 'pi pi-box',
        route: generateFullModuleRoute(
          MODULE_PATHS_CONSTANTS.LISTADO_MULTISEGUROS
        ),
        title: 'Multiseguros',
        activated: true,
      },
      {
        icon: 'pi pi-file',
        route: generateFullModuleRoute(
          MODULE_PATHS_CONSTANTS.LISTADO_GARANTIAS
        ),
        title: 'Garantía de alquiler',
        activated: true,
      },
    ],
  },
];

export const MODULE_ROUTES_NOT_MENU = [
  {
    icon: 'fas fa-chevron-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.DETALLE_AUTOMOVIL),
    title: 'Volver al listado',
    activateRoute: generateFullModuleRoute(
      MODULE_PATHS_CONSTANTS.LISTADO_AUTOMOVILES
    ),
  },
  {
    icon: 'fas fa-chevron-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.DETALLE_MULTISEGUROS),
    title: 'Detalle de renovación',
    activateRoute: generateFullModuleRoute(
      MODULE_PATHS_CONSTANTS.LISTADO_MULTISEGUROS
    ),
  },
  {
    icon: 'fas fa-chevron-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.DETALLE_GARANTIA),
    title: 'Volver al listado',
    activateRoute: generateFullModuleRoute(
      MODULE_PATHS_CONSTANTS.LISTADO_GARANTIAS
    ),
  },
];

export const CONFIG_LISTADO = {
  LIST_CAR_INSURANCE_RENEWALS: 'administrador.renovaciones.automoviles',
};

export const LIST_CAR_INSURANCE_COLUMN_NAMES = {
  RENOVATION_DATE: 'renovationDate',
  INSURED_NAME: 'insuredName',
  POLICY_NUMBER: 'policyNumber',
  CAR_REGISTRATION_NUMBER: 'carRegistrationNumber',
  COVERAGE_PACKAGE: 'coveragePackage',
  RENOVATION_PRICE: 'renovationPrice',
  STATUS: 'status',
  LAST_ACTION_DATE: 'lastActionDate',
  PAYMENT_METHOD: 'paymentMethod',
  CURRENT_PRICE: 'currentPrice',
  BROKER_NAME: 'brokerName',
  BROKER_CODE: 'brokerCode',
  ACTIONS: 'actions',
};

export const RENOVATION_STATUS_OPTIONS = [
  { name: 'Renueva', value: 'Renueva' },
  { name: 'No Renueva', value: 'No Renueva' },
  { name: 'No Renovable', value: 'No Renovable' },
];

export const PAYMENT_METHOD_STATUS = {
  COBRANZA: 'Red de Cobranza',
  TARJETA: 'Tarjeta Debito/Credito',
};

export const PAYMENT_METHOD_OPTIONS = [
  { name: 'Tarjeta débito/crédito', value: 'tarjeta_debito_credito' },
  { name: 'Red de cobranza', value: 'red_cobranza' },
  { name: 'Transferencia bancaria', value: 'transferencia_bancaria' },
  { name: 'Débito automático', value: 'debito_automatico' },
];

export const RENOVATION_STATUS = {
  RENUEVA: 'Renueva',
  NO_RENUEVA: 'No Renueva',
  NO_RENOVABLE: 'No Renovable',
};

export const RENOVATION_STATUS_CHANGE = [
  { name: 'Renueva', value: true },
  { name: 'No renueva', value: false },
];

export const RENOVATION_DUE_DAYS = {
  MAX: 45, // límite superior → >45 días sin clase
  SUCCESS: 16, // 45 a 16 días → verde
  WARNING: 6, // 15 a 6 días  → amarillo
  DANGER: 1, // 5 a 1 día    → rojo
};

export const REASONG_LIST_OTRO = {
  control: 'otro',
  label: 'Otro',
  name: 'Otro (Es necesario agregar un comentario)',
  selected: false,
};

export const REASON_LIST_NO_RENUEVA = [
  {
    control: 'motivosEconomicos',
    name: 'Motivos económicos',
    selected: false,
  },
  {
    control: 'encontroMejoresBeneficiosEnOtraAseguradora',
    name: 'Encontró mejores beneficios en otra aseguradora',
    selected: false,
  },
  {
    control: 'tuvoUnaMalaExperiencia',
    name: 'Tuvo una mala experiencia',
    selected: false,
  },
  {
    control: 'elServicioNoEraLoQueEsperaba',
    name: 'El servicio no era lo que esperaba',
    selected: false,
  },
  {
    control: 'vendioElArticuloAsegurado',
    name: 'Vendió el artículo asegurado',
    selected: false,
  },
  REASONG_LIST_OTRO,
];

export const REASON_LIST_NO_RENOVABLE = [
  {
    control: 'altaSiniestralidad',
    name: 'Alta siniestralidad',
    selected: false,
  },
  {
    control: 'frecuencia',
    name: 'Frecuencia',
    selected: false,
  },
  {
    control: 'destruccionTotal',
    name: 'Destrucción total',
    selected: false,
  },
  {
    control: 'hurtoTotal',
    name: 'Hurto total',
    selected: false,
  },
  REASONG_LIST_OTRO,
];

export const REASON_LIST_NO_RENUEVA_NO_RENOVABLE_GARANTIA = [
  {
    control: 'acuerdoPartes',
    name: 'Acuerdo de partes',
    selected: false,
  },
  {
    control: 'siniestro',
    name: 'Siniestro',
    selected: false,
  },
  REASONG_LIST_OTRO,
];

export const RENOVATION_DAYS_RANGE = {
  MIN: 1,
  MAX: 30,
};

export enum modalActionsAuto {
  DETAIL = 'detail',
  DOWNLOAD_QUOTE = 'download quote',
  CHANGE_RENEW = 'change renew',
  CHANGE_NOT_RENEW = 'change not renew',
  CHANGE_NOT_RENEWABLE = 'change not renewable',
  LINK_PAYMENT = 'link payment',
}

export enum modalActionsAutoDescription {
  DETAIL = 'Ver detalle',
  DOWNLOAD_QUOTE = 'Descargar cotización',
  CHANGE_RENEW = 'Cambiar estado (Renueva)',
  CHANGE_NOT_RENEW = 'Cambiar estado (No renueva)',
  CHANGE_NOT_RENEWABLE = 'Cambiar estado (No renovable)',
  LINK_PAYMENT = 'Enviar link de pago',
}

export const IMAGE_TYPES = ['jpg', 'jpeg', 'gif', 'png'];

export const DOCUMENT_TYPES = {
  CI: 'CI',
  RUT: 'RUT',
  EXT: 'EXT',
};

export enum ERROR_VERIFY_POLICY {
  success = '200',
  notFoundSAP = '001',
  policyExist = '002',
  policyMoreThirtyDays = '003',
  policyExpired = '004',
}

export const INVALID_FILE_TYPES = ['txt', 'odt', 'rtf', 'wpd'];

export const VALID_FILE_TYPES = [
  'pdf',
  'doc',
  'docm',
  'docx',
  'jpg',
  'jpeg',
  'png',
];
